import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function NewTransformation() {
  return <Section className="bg-forest-mist py-20" data-id="element-335">
      <div className="max-w-5xl mx-auto" data-id="element-336">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-337">
          De la incertidumbre a la tranquilidad
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-338">
          {/* Antes */}
          <Card className="p-8 bg-white/80 border-red-100 shadow-sm" data-id="element-339">
            <div className="flex items-center gap-3 mb-6" data-id="element-340">
              <XCircle className="w-8 h-8 text-red-400" data-id="element-341" />
              <h3 className="text-2xl font-bold text-forest-deep" data-id="element-342">Antes</h3>
            </div>
            <ul className="space-y-4" data-id="element-343">
              <li className="flex items-center gap-3 text-forest/80 text-lg" data-id="element-344">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 shrink-0" data-id="element-345" />
                No sé qué hacer cuando aparece un malestar.
              </li>
              <li className="flex items-center gap-3 text-forest/80 text-lg" data-id="element-346">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 shrink-0" data-id="element-347" />
                Busco durante horas en internet.
              </li>
              <li className="flex items-center gap-3 text-forest/80 text-lg" data-id="element-348">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 shrink-0" data-id="element-349" />
                Pruebo cualquier cosa por desesperación.
              </li>
              <li className="flex items-center gap-3 text-forest/80 text-lg" data-id="element-350">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 shrink-0" data-id="element-351" />
                Siento frustración e impotencia.
              </li>
            </ul>
          </Card>

          {/* Después */}
          <Card className="p-8 bg-white border-moss/30 shadow-md relative overflow-hidden" data-id="element-352">
            <div className="absolute top-0 right-0 w-32 h-32 bg-moss/10 rounded-bl-full -z-10" data-id="element-353" />
            <div className="flex items-center gap-3 mb-6" data-id="element-354">
              <CheckCircle2 className="w-8 h-8 text-moss" data-id="element-355" />
              <h3 className="text-2xl font-bold text-forest-deep" data-id="element-356">Después</h3>
            </div>
            <ul className="space-y-4" data-id="element-357">
              <li className="flex items-center gap-3 text-forest-deep font-medium text-lg" data-id="element-358">
                <span className="w-1.5 h-1.5 rounded-full bg-moss shrink-0" data-id="element-359" />
                Sé exactamente qué hacer paso a paso.
              </li>
              <li className="flex items-center gap-3 text-forest-deep font-medium text-lg" data-id="element-360">
                <span className="w-1.5 h-1.5 rounded-full bg-moss shrink-0" data-id="element-361" />
                Tengo una guía clara y confiable a mano.
              </li>
              <li className="flex items-center gap-3 text-forest-deep font-medium text-lg" data-id="element-362">
                <span className="w-1.5 h-1.5 rounded-full bg-moss shrink-0" data-id="element-363" />
                Actúo rápido y con total confianza.
              </li>
              <li className="flex items-center gap-3 text-forest-deep font-medium text-lg" data-id="element-364">
                <span className="w-1.5 h-1.5 rounded-full bg-moss shrink-0" data-id="element-365" />
                Uso ingredientes seguros que ya tengo.
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </Section>;
}